import { render, staticRenderFns } from "./add-category-dedicated.vue?vue&type=template&id=fae5234c"
import script from "./add-category-dedicated.vue?vue&type=script&lang=js"
export * from "./add-category-dedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports